import { Box } from '@mui/material'
import Header3 from '../../components/header/header-rslhome'

import Hero3 from '../../components/hero/hero-rslhome'
import Footer3 from '../../components/footer/footer-3'

export default function CompanyProfilePDF() {
  return (
    <>
      <div className='rsl-design-header'>
        <Header3 />
      </div>

      <Box sx={{ width: '100%', height: '100vh', overflow: 'hidden', marginTop: '100px' }}>
        <iframe
          src={`${process.env.IMAGE_BASE_URL}/companyProfile/companyProfile.pdf`}
          title='Company Profile'
          width='100%'
          height='100%'
          style={{ border: 'none' }}
        />
      </Box>

      <Footer3 />
    </>
  )
}
